import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

function PaginationButton({
  children,
  borderless,
  disabled = false,
  onClick,
  isActive,
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`rounded-md h-10 hover:text-brand-primary ${
        isActive ? "text-brand-primary font-bold" : "text-brand-mediumgray"
      } ${
        borderless
          ? "px-2"
          : "px-2 border-2 border-brand-mediumgray hover:border-brand-primary"
      }`}
    >
      {children}
    </button>
  );
}

function PrevButton({ currentPage, prevValue, onClick }) {
  return (
    <PaginationButton
      // onClick={() => onChangedPage(currentPage - prevValue)}
      onClick={() => onClick(currentPage - prevValue)}
      borderless
    >
      {currentPage - prevValue}
    </PaginationButton>
  );
}

function NextButton({ currentPage, nextValue, onClick }) {
  return (
    <PaginationButton
      // onClick={() => onChangedPage(currentPage + nextValue)}
      onClick={() => onClick(currentPage + nextValue)}
      borderless
    >
      {currentPage + nextValue}
    </PaginationButton>
  );
}

function isPositive(val) {
  return val > 0;
}

export default function Pagination({
  pages,
  currentPage,
  onChangedPage,
  onPrevClick,
  onNextClick,
  className,
}) {
  const morePages = pages - currentPage > 2;
  // Checar si exiten muchas mas paginas previas.
  const morePrevPage = currentPage > 3;
  const isPrevEnable = currentPage > 1;
  const isNextEnable = currentPage !== pages;

  return (
    <div
      id="pagination"
      className={`flex gap-1 justify-center w-full md:h-auto ${className}`}
    >
      <PaginationButton disabled={!isPrevEnable} onClick={onPrevClick}>
        <FaAngleLeft fontSize={22} />
      </PaginationButton>
      {morePrevPage && <PaginationButton borderless>...</PaginationButton>}
      {isPositive(currentPage - 2) && currentPage - 2 < pages && (
        <PrevButton
          currentPage={currentPage}
          prevValue={2}
          onClick={onChangedPage}
        />
      )}
      {isPositive(currentPage - 1) && (
        <PrevButton
          currentPage={currentPage}
          prevValue={1}
          onClick={onChangedPage}
        />
      )}
      {
        <PaginationButton
          disabled
          onClick={() => onChangedPage(currentPage)}
          isActive
          borderless
        >
          {currentPage}
        </PaginationButton>
      }
      {isPositive(currentPage + 1) && currentPage + 1 <= pages && (
        <NextButton
          currentPage={currentPage}
          nextValue={1}
          onClick={onChangedPage}
        />
      )}
      {isPositive(currentPage + 2) && currentPage + 2 <= pages && (
        <NextButton
          currentPage={currentPage}
          nextValue={2}
          onClick={onChangedPage}
        />
      )}
      {morePages && <PaginationButton borderless>...</PaginationButton>}
      <PaginationButton disabled={!isNextEnable} onClick={onNextClick}>
        <FaAngleRight fontSize={22} />
      </PaginationButton>
    </div>
  );
}
